import { render, staticRenderFns } from "./YetkiGecisiView.vue?vue&type=template&id=81fdb334"
import script from "./YetkiGecisiView.vue?vue&type=script&lang=ts"
export * from "./YetkiGecisiView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports